import React, { useState } from 'react';
import Close from 'components/common/Close/Close';
import { white, black40 } from 'styles/common/_constants.scss';
import { useClickOutside, useIsMobile, useToast } from 'hooks';
import { defineMessages, useIntl } from 'react-intl';
import Input from 'components/common/Input/Input';
import Button from 'components/common/Button/Button';
import { func } from 'prop-types';
import parseError from 'utils/parseError';
import celebritiesService from 'services/celebritiesService';
import Loading from 'components/common/Loading';
import { toast } from 'react-toastify';

const messages = defineMessages({
  dmPlaceholder: { id: 'form.dmPlaceholder' },
  dmTitle: { id: 'form.dmTitle' },
  message: { id: 'form.dmMessage' }
});
const DmModal = ({ hide, handleCloseDropDown }) => {
  const intl = useIntl();
  const isMobile = useIsMobile();
  const ref = useClickOutside(hide);
  const { showToast } = useToast();
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleDmChange = e => {
    const { value } = e.target;
    setMessage(value);
    if (value.length > 150) {
      setError('Message must be 150 characters or less');
    } else {
      setError('');
    }
  };

  const handleSubmit = async () => {
    if (message.length > 150) {
      toast.error('Message must be 150 characters or less');
      return;
    }

    try {
      setLoading(true);
      const data = { dm: { message } };
      await celebritiesService.sendDirectMessage(data);
      setLoading(false);
      showToast('DM successfully sent!');
      hide();
      handleCloseDropDown();
    } catch ({ response }) {
      setLoading(false);
      throw parseError(response);
    }
  };

  return (
    <div className="serie-landing" ref={ref}>
      <div className="serie-landing-header">
        {intl.formatMessage(messages.dmTitle)}{' '}
        <Close onClick={hide} color={isMobile ? white : black40} />
      </div>
      <div className="layer serie-landing-header-content">
        <div className="dm-div">
          <span>{intl.formatMessage(messages.message)}</span>
          <div className="dm-form-fields">
            <Input
              name="dm"
              placeholder={intl.formatMessage(messages.dmPlaceholder)}
              onChange={handleDmChange}
              maxLength={150}
              value={message}
            />
            <Button
              type="primary"
              labelId="form.shareBtn"
              onClick={handleSubmit}
              disabled={!message || loading || message.length > 150}
            >
              {loading && <Loading type="ball-clip-rotate" />}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

DmModal.propTypes = {
  hide: func.isRequired,
  handleCloseDropDown: func.isRequired
};

export default DmModal;
